import {formatFileSize, getFileExtension} from '@sollapay/utils';

import {DoneItem} from './DoneItem';
import {UploadingItem} from './UploadingItem';

export interface FileUploadItemProps {
  fileName: string;
  fileSize: number;
  /** When defined (0–100) → renders uploading state with progress bar */
  progress?: number;
  /** e.g. "6.4 MB of 16 MB" — shown in uploading state */
  uploadedBytesLabel?: string;
  /** Label for the uploading status text */
  uploadingLabel?: string;
  /** Display string for upload time — shown in done state */
  uploadedAt?: string;
  onRemove?: () => Promise<void>;
  onDownload?: () => Promise<void>;
  onView?: () => Promise<void>;
  isLoading?: boolean;
  deleteLabel?: string;
  downloadLabel?: string;
  viewLabel?: string;
}

export function FileUploadItem({
  fileName,
  fileSize,
  progress,
  uploadedBytesLabel,
  uploadingLabel = 'Uploading…',
  uploadedAt,
  onRemove,
  onDownload,
  onView,
  isLoading = false,
  deleteLabel,
  downloadLabel,
  viewLabel
}: FileUploadItemProps) {
  const isUploading = progress !== undefined;
  const ext = getFileExtension(fileName);
  const sizeLabel = formatFileSize(fileSize);

  return isUploading ? (
    <UploadingItem
      fileName={fileName}
      progress={progress}
      uploadedBytesLabel={uploadedBytesLabel ?? sizeLabel}
      uploadingLabel={uploadingLabel}
      onRemove={onRemove}
      isLoading={isLoading}
      ext={ext}
    />
  ) : (
    <DoneItem
      fileName={fileName}
      sizeLabel={sizeLabel}
      uploadedAt={uploadedAt}
      onRemove={onRemove}
      onDownload={onDownload}
      onView={onView}
      isLoading={isLoading}
      ext={ext}
      deleteLabel={deleteLabel}
      downloadLabel={downloadLabel}
      viewLabel={viewLabel}
    />
  );
}
